import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from "axios";
import './index.scss'
import Loading from '../../components/Loading';

function ShortUrlDocuSign() {
    const { id } = useParams();
    const [msg,setMsg] = useState("Aguarde enviando para DocuSign!")
    
    async function execute(){
      try{
        let ret = await axios.get(`/docusign/short/${id}`)
        let {data} = ret
        console.log(data)
        window.location.href = data['url']  
      }catch(e){
        let {response} = e
        if(response){
          if(response.status == 404){
            setMsg("Link inválido!")
          }
        }
      }
    }
    execute();

  return (
    <div className="not-found">
        <h2>
        {msg}
        </h2>
    </div>
  )
}

export default ShortUrlDocuSign
